import React from "react";
import './leftside.css';
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import Menu from "./Menu";
import LeftMenuLogo from "./Logo";

class LeftMenuDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            expandVal: "no"
        }
    }

    componentDidMount() { }
    componentWillUnmount() {
    }


    expand = () => {
        if (this.state.expandVal == "no") {
            setTimeout(() => {
                this.setState({
                    expandVal: "yes"
                })
            }, 100);


        }
        if (this.state.expandVal == "yes") {
            setTimeout(() => {
                this.setState({
                    expandVal: "no"
                })
            }, 100);


        }

    }


    render() {

        return (


            <div class={this.state.expandVal == "yes" ?
                "left-side active" : "left-side"} id="left-menu">
                <LeftMenuLogo />
                {/* <Menu /> */}

                <div>
                    <div class="menubtn" onClick={this.expand} >
                        <button type="button" class={this.state.expandVal == "yes" ?
                            "navbar-toggler open" : "navbar-toggler"} id="menubtn" onClick={this.expand}
                            title={this.state.expandVal == "yes" ?
                                "collapse" : "expand"}  >
                            <span></span>
                            <span></span>
                            <span></span>

                        </button>
                    </div>
                    {this.state.expandVal == "yes" ?
                        <div class="menu" id="menu">
                            <ul>
                                <li><Link to="/dashboard" ><i class="dash" title="Dashboard"></i> Dashboard</Link></li>
                                <li><Link to="/manage-consumer"><i class="csmr" title="manage-consumer"></i>Manage Consumer</Link></li>
                                <li><Link to="/bill-history"><i class="billpay" title="bill-history"></i> Bill History</Link></li>
                                {/* <li><Link to="/account-ledger"><i class="ledgr" title="account-ledger"></i> Account Ledger</Link></li> */}
                                <li><Link to="/manage-payment"><i class="mgpayt" title="manage-payment"></i> Manage Payment</Link></li>
                            </ul>
                        </div> :
                        <div class="menu" id="menu">
                            <ul>
                            <li><Link to="/dashboard" ><i class="dash" title="Dashboard"></i></Link></li>
                                <li><Link to="/manage-consumer"><i class="csmr" title="manage-consumer"></i></Link></li>
                                <li><Link to="/bill-history"><i class="billpay" title="bill-history"></i></Link></li>
                                {/* <li><Link to="/account-ledger"><i class="ledgr" title="account-ledger"></i></Link></li> */}
                                <li><Link to="/manage-payment"><i class="mgpayt" title="manage-payment"></i></Link></li>
                            </ul>
                        </div>

                    }
                </div>
            </div>


        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { otpRefNo, phone } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone
});

export default connect(mapStateToProps, null)(LeftMenuDetails);
